import { Modal } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';

interface ManualTaggingModalProps {
  open: boolean;
  onClose: () => void;
  tagManuallyHandler: () => void;
  autoTagHandler: () => void;
}

const Content = styled.div`
  padding: 24px;

  color: #414141;
  font-family: Lato;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18.2px;

  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const ManualTaggingModal: React.FC<ManualTaggingModalProps> = (props) => {
  const { open, onClose, tagManuallyHandler, autoTagHandler } = props;

  const tagManuallyBtn = {
    label: 'Tag manually',
    onClick: tagManuallyHandler,
  };

  const autoTagBtn = {
    label: 'Maintain auto-tag',
    onClick: autoTagHandler,
  };

  return (
    <Modal
      title='Confirm tagging method'
      open={open}
      onClose={onClose}
      maxWidth='xs'
      fullWidth
      cancelBtn={tagManuallyBtn}
      confirmBtn={autoTagBtn}
    >
      <Content>
        <div>Auto-tag is enabled on this game, meaning the game’s meta and tracking data will be merged automatically.</div>
        <div>If you choose to tag this game manually, this cannot be reversed.</div>
      </Content>
    </Modal>
  );
};
